import { lessonPdfPublicUrl } from "../../../components/student/PdfPreviewModal";

export function isValidQuestionAsset(value) {
  return value && value !== "null" && value !== "undefined";
}

export function isPdfAsset(value) {
  if (!isValidQuestionAsset(value)) return false;
  if (typeof File !== "undefined" && value instanceof File) {
    return (
      value.type === "application/pdf" ||
      String(value.name || "").toLowerCase().endsWith(".pdf")
    );
  }
  const s = String(value).toLowerCase();
  return s.endsWith(".pdf") || s.includes(".pdf?") || s.includes("application/pdf");
}

const IMAGE_BASE = "https://edutopiaonline.com/api";

/** Image/public asset URL (legacy host used for question images). */
export function questionAssetUrl(path, baseUrl = IMAGE_BASE) {
  if (!isValidQuestionAsset(path)) return "";
  if (typeof path === "string" && /^https?:\/\//i.test(path)) return path;
  if (typeof path === "string" && path.startsWith("blob:")) return path;
  const clean = String(path).replace(/^\//, "");
  return `${String(baseUrl).replace(/\/$/, "")}/${clean}`;
}

/** PDF URL using the same public API base as exam/lesson PDF preview. */
export function questionPdfUrl(path) {
  if (!isValidQuestionAsset(path)) return "";
  if (typeof path === "string" && /^https?:\/\//i.test(path)) return path;
  if (typeof path === "string" && path.startsWith("blob:")) return path;
  return lessonPdfPublicUrl(path);
}
